<template lang="pug" src="./tab-office-doctor.pug"></template>

<script>
export default {
  data () {
    return {
      activeTab: 'education',
      titleActive: false
    }
  },
  props: ['props']
}
</script>



// WEBPACK FOOTER //
// tab-office-doctor.vue?3ca5a696